import React from "react";
import { Button } from "../../../../ui/button";
import { Search } from "lucide-react";
import { Input } from "../../../../ui/input";

const PracticeConnectionsCardHeader = (props) => {
  const {
    practicesConnected,
    localSelectedPractices,
    handleCheckAllLocalPractices,
    handleUnCheckAllLocalPractices,
    practiceFilter,
    setPracticeFilter,
    canUseMultiPractice,
  } = props;
  return (
    <div className="flex justify-between items-center px-6 practice-connection-header">
      <div className="flex flex-col justify-between py-3">
        <span className="text-lg font-medium text-gray-700 !mb-0">
          Practice Connections
        </span>
        <p className="text-gray-500 !mb-0">
          {practicesConnected?.length} of {localSelectedPractices.length}{" "}
          practices selected
        </p>
      </div>
      <div className="practice-connection-header-actions gap-3">
        {canUseMultiPractice && (
          <div className="flex gap-3 w-full">
            <Button
              size="sm"
              variant="outline"
              className="!rounded-xl !px-5 !py-5 !flex items-center !justify-between !gap-[2rem] !text-gray-600 !hover:bg-accent !hover:text-accent-foreground practice-connection-action-button"
              onClick={handleCheckAllLocalPractices}
              disabled={
                practicesConnected.length === localSelectedPractices.length
              }
            >
              Select All
            </Button>
            <Button
              size="sm"
              variant="outline"
              className="!rounded-xl !px-5 !py-5 !flex items-center !justify-between !gap-[2rem] !text-gray-600 !hover:bg-accent !hover:text-accent-foreground practice-connection-action-button"
              onClick={handleUnCheckAllLocalPractices}
              disabled={practicesConnected.length <= 0}
            >
              Deselect All
            </Button>{" "}
          </div>
        )}

        <div className="relative container-input-width">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <Input
            placeholder="Search practices..."
            value={practiceFilter}
            onChange={(e) => setPracticeFilter(e.target.value)}
            className="pl-10 input-transaction-width !px-5 allTransactionSearchInput"
          />
        </div>
      </div>
    </div>
  );
};

export default PracticeConnectionsCardHeader;
